import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { GetStartedCarousel } from '../GetStartedCarousel';
import { BaseHeader, PromoPill } from '../../molecules';
import { LinkButton, ResponsiveText, HideOnMobile } from '../../atoms';
import { SLIDES } from '../GetStartedCarousel/constants';
import { onboardingInitiated } from '../events';
import { useReporter } from '../../reporter';
import {
  CenteredCarousel,
  PageWrapper,
  Wrapper,
  ButtonContainer,
} from './styles';

export const GetStartedContainer = ({
  continuePath,
  continueTextMobile,
  continueTextDesktop,
}) => {
  const reporter = useReporter();

  useEffect(() => {
    reporter.tag(onboardingInitiated());
  }, [reporter]);

  return (
    <PageWrapper>
      <BaseHeader
        rightSegment={
          <HideOnMobile>
            <PromoPill />
          </HideOnMobile>
        }
      />
      <Wrapper>
        <CenteredCarousel>
          <GetStartedCarousel slides={SLIDES}></GetStartedCarousel>
        </CenteredCarousel>
        <ButtonContainer>
          <LinkButton
            disabled={!!continuePath}
            href={continuePath ?? '#'}
            variant="spinach"
            fullWidth={true}
            verticalPadding={5}
            horizontalPadding={8}
          >
            <ResponsiveText
              mobileText={continueTextMobile}
              desktopText={continueTextDesktop}
            />
          </LinkButton>
        </ButtonContainer>
      </Wrapper>
    </PageWrapper>
  );
};

GetStartedContainer.propTypes = {
  continuePath: PropTypes.string,
  continueTextMobile: PropTypes.string.isRequired,
  continueTextDesktop: PropTypes.string.isRequired,
};
